import { render, staticRenderFns } from "./_setDialog.vue?vue&type=template&id=2285e0d8&scoped=true"
import script from "./_setDialog.vue?vue&type=script&lang=js"
export * from "./_setDialog.vue?vue&type=script&lang=js"
import style0 from "./_setDialog.vue?vue&type=style&index=0&id=2285e0d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285e0d8",
  null
  
)

export default component.exports